module.exports = __webpack_public_path__ + "img/cert-xuqian.ff835f79.svg";